import { useEffect, useState } from "react";
import { ArrowUpDown } from "lucide-react";

export default function PrefCell({ value, onSave, testId }) {
  const [v, setV] = useState(value || "");
  useEffect(() => { setV(value || ""); }, [value]);
  const commit = () => { if ((v || "").trim() !== (value || "")) onSave((v || "").trim()); };
  return (
    <div
      className="flex items-center gap-1 shrink-0 rounded-lg border border-border bg-secondary/60 pl-1.5 focus-within:ring-1 focus-within:ring-primary focus-within:border-primary"
      title="Preferencia: orden dentro del nivel"
    >
      <ArrowUpDown className="h-3.5 w-3.5 text-muted-foreground" />
      <input
        value={v}
        onChange={(e) => setV(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); e.currentTarget.blur(); } }}
        placeholder="Pref."
        aria-label="Preferencia (orden dentro del nivel)"
        data-testid={testId}
        className="h-7 w-11 rounded-r-lg bg-transparent px-1 text-xs font-medium text-center focus:outline-none placeholder:text-muted-foreground/70"
      />
    </div>
  );
}
